@layer refine.base {
  :host {
    display: block;
  }

  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: none;
  }

  legend {
    padding: 0;
    margin-bottom: var(--size-2);
    font-size: var(--text-sm);
    font-weight: var(--font-medium);
    color: var(--color-contrast-600);
  }

  legend[hidden] {
    display: none;
  }

  .radio-group-items {
    display: flex;
    flex-direction: var(--radio-group-direction, column);
    gap: var(--radio-group-gap, var(--size-2));
  }

  .helper-text[hidden] {
    display: none;
  }

  .helper-text {
    padding-inline: 2px;
    margin-top: var(--size-1-5);
    font-size: var(--text-xs);
    line-height: var(--leading-tight);
    color: color-mix(in oklch, var(--color-contrast-500) 80%, var(--color-canvas));
  }

  .error-text {
    padding-inline: 2px;
    margin-top: var(--size-1-5);
    font-size: var(--text-xs);
    line-height: var(--leading-tight);
    color: var(--color-error);
  }
}

@layer refine.variants {
  :host([orientation='horizontal']) .radio-group-items {
    --radio-group-direction: row;

    flex-wrap: wrap;
  }
}
